/**
 * Internal dependencies
 */
import getPosition from "./get-position";

/**
 * Animation easing function
 *
 * @param  {number} t Animationt time.
 * @param  {number} b Start value.
 * @param  {number} c Change in value.
 * @param  {number} d Duration.
 * @return {number}   Position.
 */
const easeInOutQuad = function(t, b, c, d) {
	t /= d / 2;
	if (t < 1) {
		return (c / 2) * t * t + b;
	}
	t--;
	return (-c / 2) * (t * (t - 2) - 1) + b;
};

export default class {
	constructor(options) {
		const defaults = {
			duration: 500,
			offset: 0,
		};

		this.options = {
			...defaults,
			...options,
		};

		this.animating = false;
		this.disabled = false;

		this.init();

		this.handleHashChange = this.handleHashChange.bind(this);

		window.addEventListener("DOMContentLoaded", this.handleHashChange);
		window.addEventListener("hashchange", this.handleHashChange);
	}

	init() {
		document.body.addEventListener("click", e => {
			const href = e.target.getAttribute("href");

			if (
				e.target.nodeName === "A" &&
				href &&
				href.startsWith("#") &&
				href.length > 1
			) {
				const target = document.querySelector(href);

				if (target) {
					this.scrollToElement(target);
				}
			}
		});
	}

	enable() {
		this.disabled = false;
	}

	disable() {
		this.disabled = true;
	}

	handleHashChange() {
		if (this.animating || this.disabled) {
			return;
		}

		const element = document.getElementById(window.location.hash.substr(1));

		if (element) {
			this.scrollToElement(element);
		}
	}

	scrollToElement(target) {
		this.animating = true;

		if ("function" === typeof this.options.onScrollStart) {
			this.options.onScrollStart();
		}

		const offset =
			"function" === typeof this.options.offset
				? this.options.offset(target)
				: this.options.offset;

		const to = getPosition(target).y - offset;

		this.startPosition = document.scrollingElement.scrollTop;
		this.delta = to - this.startPosition;

		this.animate();
	}

	animate() {
		window.requestAnimationFrame(this.handleAnimation.bind(this));
	}

	handleAnimation(timestamp) {
		if (!this.startTime) {
			this.startTime = timestamp;
		}

		const progress = timestamp - this.startTime;

		document.scrollingElement.scrollTop = easeInOutQuad(
			progress,
			this.startPosition,
			this.delta,
			this.options.duration
		);

		if (progress < this.options.duration) {
			this.animate();
		} else {
			this.startTime = undefined;
			this.startPosition = undefined;
			this.delta = undefined;
			this.animating = false;

			if ("function" === typeof this.options.onScrollFinish) {
				this.options.onScrollFinish();
			}
		}
	}
}
